/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { priceListCategoriesControllerCreate } from '../fn/price-list-categories/price-list-categories-controller-create';
import { PriceListCategoriesControllerCreate$Params } from '../fn/price-list-categories/price-list-categories-controller-create';
import { priceListCategoriesControllerFindAllByTenant } from '../fn/price-list-categories/price-list-categories-controller-find-all-by-tenant';
import { PriceListCategoriesControllerFindAllByTenant$Params } from '../fn/price-list-categories/price-list-categories-controller-find-all-by-tenant';
import { priceListCategoriesControllerFindOne } from '../fn/price-list-categories/price-list-categories-controller-find-one';
import { PriceListCategoriesControllerFindOne$Params } from '../fn/price-list-categories/price-list-categories-controller-find-one';
import { priceListCategoriesControllerRemove } from '../fn/price-list-categories/price-list-categories-controller-remove';
import { PriceListCategoriesControllerRemove$Params } from '../fn/price-list-categories/price-list-categories-controller-remove';
import { priceListCategoriesControllerUpdate } from '../fn/price-list-categories/price-list-categories-controller-update';
import { PriceListCategoriesControllerUpdate$Params } from '../fn/price-list-categories/price-list-categories-controller-update';
import { SalesPriceListCategoryResponseDto } from '../models/sales-price-list-category-response-dto';

@Injectable({ providedIn: 'root' })
export class SalesPriceListCategoriesService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `priceListCategoriesControllerFindAllByTenant()` */
  static readonly PriceListCategoriesControllerFindAllByTenantPath = '/o2-sales/price-list-categories/{tenant}';

  /**
   * Retrieve price list categories by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListCategoriesControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerFindAllByTenant$Response(params: PriceListCategoriesControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesPriceListCategoryResponseDto>>> {
    const obs = priceListCategoriesControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve price list categories by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListCategoriesControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerFindAllByTenant(params: PriceListCategoriesControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesPriceListCategoryResponseDto>> {
    const resp = this.priceListCategoriesControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesPriceListCategoryResponseDto>>): Array<SalesPriceListCategoryResponseDto> => r.body)
    );
  }

  /** Path part for operation `priceListCategoriesControllerCreate()` */
  static readonly PriceListCategoriesControllerCreatePath = '/o2-sales/price-list-categories/{tenant}';

  /**
   * Create a new price list category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListCategoriesControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListCategoriesControllerCreate$Response(params: PriceListCategoriesControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
    const obs = priceListCategoriesControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new price list category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListCategoriesControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListCategoriesControllerCreate(params: PriceListCategoriesControllerCreate$Params, context?: HttpContext): Observable<SalesPriceListCategoryResponseDto> {
    const resp = this.priceListCategoriesControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>): SalesPriceListCategoryResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListCategoriesControllerFindOne()` */
  static readonly PriceListCategoriesControllerFindOnePath = '/o2-sales/price-list-categories/{tenant}/id/{id}';

  /**
   * Retrieve a price list category by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListCategoriesControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerFindOne$Response(params: PriceListCategoriesControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
    const obs = priceListCategoriesControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a price list category by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListCategoriesControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerFindOne(params: PriceListCategoriesControllerFindOne$Params, context?: HttpContext): Observable<SalesPriceListCategoryResponseDto> {
    const resp = this.priceListCategoriesControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>): SalesPriceListCategoryResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListCategoriesControllerRemove()` */
  static readonly PriceListCategoriesControllerRemovePath = '/o2-sales/price-list-categories/{tenant}/{id}';

  /**
   * Delete a price list category by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListCategoriesControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerRemove$Response(params: PriceListCategoriesControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
    const obs = priceListCategoriesControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a price list category by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListCategoriesControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  priceListCategoriesControllerRemove(params: PriceListCategoriesControllerRemove$Params, context?: HttpContext): Observable<SalesPriceListCategoryResponseDto> {
    const resp = this.priceListCategoriesControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>): SalesPriceListCategoryResponseDto => r.body)
    );
  }

  /** Path part for operation `priceListCategoriesControllerUpdate()` */
  static readonly PriceListCategoriesControllerUpdatePath = '/o2-sales/price-list-categories/{tenant}/{id}';

  /**
   * Update a price list category by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `priceListCategoriesControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListCategoriesControllerUpdate$Response(params: PriceListCategoriesControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
    const obs = priceListCategoriesControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a price list category by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `priceListCategoriesControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  priceListCategoriesControllerUpdate(params: PriceListCategoriesControllerUpdate$Params, context?: HttpContext): Observable<SalesPriceListCategoryResponseDto> {
    const resp = this.priceListCategoriesControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>): SalesPriceListCategoryResponseDto => r.body)
    );
  }

}
